// frontend-react/src/components/sales/CartTable.jsx
import React from 'react';
import CartRow from './CartRow.jsx';
function fmtXof(n) {
  return Number(n || 0).toLocaleString('fr-FR');
}

export default function CartTable({
  lines,
  products,
  variantsCache,
  onRemove,
  onUpdateQty,
  onUpdateVariant,
  onUpdateNotes,
}) {
  function renderVariantOptionLabel(v, type, selectedVariants) {
    const label = v?.label || v?.code;
    const delta = Number(v?.price_delta ?? 0);
    if (Number.isFinite(delta) && delta !== 0) {
      const sign = delta > 0 ? '+' : '-';
      return `${label} (${sign}${Math.abs(delta).toLocaleString('fr-FR')} XOF)`;
    }
    return label;
  }

  if (lines.length === 0) {
    return <div className="py-2 text-sm text-content-secondary">Aucune ligne</div>;
  }

  return (
    <ul className="mt-4 divide-y">
      {lines.map(line => {
        const product = products.find(x => x.id === line.productId);
        return (
          <CartRow
            key={line.id}
            line={line}
            product={product}
            variantsCache={variantsCache}
            onRemove={onRemove}
            onUpdateQty={onUpdateQty}
            onUpdateVariant={onUpdateVariant}
            onUpdateNotes={onUpdateNotes}
            renderVariantOptionLabel={renderVariantOptionLabel}
          />
        );
      })}
    </ul>
  );
}
